import React from 'react'
import Useletter from '../Useletter'
import Foter from '../Foter'
function Return() {
  return (
    <div>
       
<div className="con" style={{display:"flex"}}>
                <div class="con1" style={{width:"50%",fontSize:"14px",fontFamily:"Alata,sans serif",marginLeft:""}}>
        <h2 style={{marginBottom:"35px",marginTop:"35px",fontFamily:"Alata,sans serif",fontSize:"26px",}}>RETURNS &<br /> EXCHANGES</h2>
        <ul style={{listStyle:"none"}}>
            <li  style={{marginBottom:"15px"}} class="active">Return and Exchange Policy</li>
            <li style={{marginBottom:"15px"}}>How do I Apply For A Return?</li>
            <li style={{marginBottom:"15px"}}>When Will My Return Be Processed?</li>
            <li style={{marginBottom:"15px"}} >Do You Offer Refunds?</li>
           <li style={{marginBottom:"15px"}}>Voucher Redemption Policy</li>
            <li style={{marginBottom:"15px"}}>International Orders</li>
            <li style={{marginBottom:"15px"}}>Customized and Make to Orders</li>
        </ul>
    </div>
   
            <div className="con2" style={{width:"750px",height:"auto",marginRight:"150px"}}>
            <h2 style={{marginTop:"35px",fontFamily:"Alata,sans serif",fontSize:"26px",}}>RETURNS AND EXCHANGE POLICY</h2>
            <p>You have 03 days from the date of delivery to claim for the return or exchange if:</p>
          
            <ul style={{fontFamily:"Alata,sans serif",fontSize:"16px"}}>
                <li style={{marginBottom:"15px",fontSize:"16px"}}>The product is damaged, stained, defected, wrong or incomplete. The product/s must be unused in the original packaging with labels and protective stickers attached.</li>
                <li style={{marginBottom:"15px"}}>The product received does not match the size ordered.</li>
                <li style={{marginBottom:"15px"}}>In case you receive an opened or unsealed box or packaging, please inform us immediately to avoid any claims.</li>
                <li style={{marginBottom:"15px"}}>Provide all the required information to our representative, and if all the conditions of the exchange are met, we will schedule the pick-up from your doorstep or route you to the nearest outlet for exchange purposes.</li>
                <li style={{marginBottom:"15px"}}>Exchanges during a sale or on a discounted product are ONLY applicable if the product received does not match the product you have ordered.</li>
                <li style={{marginBottom:"15px"}}>If you are unsatisfied with the size you purchased and would like to receive a different size, you can email us at <a href="mailto:eshop@junaidjamshed.com">eshop@junaidjamshed.com</a>.</li>
                <li style={{marginBottom:"15px"}}>Due to differences in color monitors/screens and lighting used during photo shoots, the exact color or texture of the final item may slightly vary from what is seen on screen, therefore products cannot be exchanged for this reason.</li>
                <li style={{marginBottom:"15px"}}>The policies listed above are applicable for orders delivered within Pakistan.</li>
                <li style={{marginBottom:"15px"}}>Please be advised that inner-wear products are non-returnable/exchangeable due to the nature of the products and to maintain hygiene standards.</li>
                <li style={{marginBottom:"15px"}}>Fragrances, cosmetics, and jewelry are neither exchangeable nor returnable.</li>
            </ul>
          

            <p>Please Note: <span style={{color: "red"}}>In the unfortunate event that you receive a damaged or defective product, we kindly ask that you provide clear evidence, such as images or videos, showcasing the issue within 03 days of delivery. This step is mandatory for us to address your concern effectively. Upon receiving your proof, our team will promptly investigate the matter and ensure an appropriate resolution is provided.</span></p>
            </div>
          
          
            </div> {/* conend */}
          <Useletter/>
          <Foter/>
           
    </div>
  )
}

export default Return
